import React from 'react';
import classes from './contactDetails.module.css';
import WhatsApp from '../../../assets/images/whatsapp.png';
import Facebook from '../../../assets/images/facebook.png';
import LinkedIn from '../../../assets/images/linkedin.png';
import Youtube from '../../../assets/images/youtube.png';
import SnapChat from '../../../assets/images/snapchat.png';
import Instagram from '../../../assets/images/instagram.png';
import Twitter from '../../../assets/images/twitter.png';
import Tiktok from '../../../assets/images/tiktok.png';
import Email from '../../../assets/images/email.png';
import Telephone from '../../../assets/images/Telephone.png';
import Location from '../../../assets/images/location-on-map.png';
import Copy from '../../../assets/images/copy.png';

const ContactDetails = () => {
    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text)
            .then(() => {})
            .catch((err) => {});
    };
    return (
        <div className={classes.ContactDetails}>
            <div className={classes.Section}>
                <h3 className={classes.SectionTitle}>
                    {parseInt(localStorage.getItem('language')) === 1 ? "Contact Details" : "معلومات الاتصال"}
                </h3>
                <div className={classes.ContactItem}>
                    <div>
                        <img src={Telephone} alt="telephone icon" />
                        <a 
                            href="tel:+962796660022" 
                            className={classes.ContactLink} 
                            style={{ 
                                direction: 'ltr', 
                                unicodeBidi: 'embed', 
                                display: 'inline-block',
                                textAlign: 'left'
                            }}
                        >
                            +962 79 666 00 22
                        </a>
                    </div>
                    <img src={Copy} alt="copy icon" className={classes.CopyIcon}
                        onClick={() => copyToClipboard("+962 79 666 00 22")} />
                </div>
                <div className={classes.ContactItem}>
                    <div>
                        <img src={Email} alt="email icon" />
                        <a href="mailto:info@6yard.com" className={classes.ContactLink}>info@6yard.com</a>
                    </div>
                    <img src={Copy} alt="copy icon" className={classes.CopyIcon}
                        onClick={() => copyToClipboard("info@6yard.com")} />
                </div>
                <div className={classes.ContactItem}>
                    <div>
                        <img src={Location} alt="location icon" />
                        <a href="https://www.google.com/maps/place/6+Yard+Football+Academy+(Entertainment+Complex)/@32.0000473,35.8771267,17z/data=!4m14!1m7!3m6!1s0x151ca8776c6f2a2b:0x74dfd640f5576ce2!2s6+Yard+Football+Academy+(Entertainment+Complex)!8m2!3d32.0000473!4d35.8745518!16s%2Fg%2F11cs0s46hj!3m5!1s0x151ca8776c6f2a2b:0x74dfd640f5576ce2!8m2!3d32.0000473!4d35.8745518!16s%2Fg%2F11cs0s46hj?authuser=0&entry=ttu&g_ep=EgoyMDI0MTAwOS4wIKXMDSoASAFQAw%3D%3D"
                            className={classes.ContactLink} target='_blank'>
                            {parseInt(localStorage.getItem('language')) === 1 ? "View on google map" : "عرض على خرائط جوجل"}
                        </a>
                    </div>
                    <img src={Copy} alt="copy icon" className={classes.CopyIcon}
                        onClick={() => copyToClipboard("https://www.google.com/maps/place/6+Yard+Football+Academy+(Entertainment+Complex)/@32.0000473,35.8771267,17z/data=!4m14!1m7!3m6!1s0x151ca8776c6f2a2b:0x74dfd640f5576ce2!2s6+Yard+Football+Academy+(Entertainment+Complex)!8m2!3d32.0000473!4d35.8745518!16s%2Fg%2F11cs0s46hj!3m5!1s0x151ca8776c6f2a2b:0x74dfd640f5576ce2!8m2!3d32.0000473!4d35.8745518!16s%2Fg%2F11cs0s46hj?authuser=0&entry=ttu&g_ep=EgoyMDI0MTAwOS4wIKXMDSoASAFQAw%3D%3D")} />
                </div>
            </div>

            <hr className={classes.Separator} />

            <div className={classes.Section}>
                <h3 className={classes.SectionTitle}>
                    {parseInt(localStorage.getItem('language')) === 1 ? "Operation Hours" : "ساعات العمل"}
                </h3>
                <div className={classes.Operation}>
                    <p className={classes.OperationDetails}>
                        {parseInt(localStorage.getItem('language')) === 1 ? "Reservations: 24 / 7" : "الحجوزات: ٢٤ / ٧"}
                    </p>
                    <p className={classes.OperationDetails}>
                        {parseInt(localStorage.getItem('language')) === 1 
                            ? "Management: 9 AM to 7 PM" 
                            : "الإدارة: ٩ صباحاً إلى ٧ مساءً"}
                    </p>
                </div>
            </div>

            <hr className={classes.Separator} />

            <div className={classes.Section}>
                <h3 className={classes.SectionTitle}>
                    {parseInt(localStorage.getItem('language')) === 1 ? "Social Media" : "وسائل التواصل الاجتماعي"}
                </h3>
                <div className={classes.List}>
                    <a href='https://wa.me/962790899534' target='_blank' rel="noreferrer"><img src={WhatsApp} alt="whatsApp icon" /></a>
                    <a href='https://www.facebook.com/6yardjo/' target='_blank' rel="noreferrer"><img src={Facebook} alt="facebook icon" /></a>
                    <a href='https://www.linkedin.com/company/6yard/' target='_blank' rel="noreferrer"><img src={LinkedIn} alt="linkedIn icon" /></a>
                    <a href='https://www.youtube.com/channel/UCgkloVt4t9ViPz5heAu5gSQ?view_as=subscriber' target='_blank' rel="noreferrer"><img src={Youtube} alt="youtube icon" /></a>
                    <a href='https://www.snapchat.com/sixyardjo' target='_blank' rel="noreferrer"><img src={SnapChat} alt="snapChat icon" /></a>
                    <a href='https://www.instagram.com/6yardjo/' target='_blank' rel="noreferrer"><img src={Instagram} alt="instagram icon" /></a>
                    <a href='https://x.com/6yardjo' target='_blank' rel="noreferrer"><img src={Twitter} alt="twitter icon" /></a>
                    <a href='https://www.tiktok.com/6yardjo' target='_blank' rel="noreferrer"><img src={Tiktok} alt="tiktok icon" /></a>
                </div>
                <div className={classes.MobileList}>
                    <a href='https://wa.me/962790899534' target='_blank' rel="noreferrer"><img src={WhatsApp} alt="whatsApp icon" /></a>
                    <a href='https://www.facebook.com/6yardjo/' target='_blank' rel="noreferrer"><img src={Facebook} alt="facebook icon" /></a>
                    <a href='https://www.linkedin.com/company/6yard/' target='_blank' rel="noreferrer"><img src={LinkedIn} alt="linkedIn icon" /></a>
                    <a href='https://www.youtube.com/channel/UCgkloVt4t9ViPz5heAu5gSQ?view_as=subscriber' target='_blank' rel="noreferrer"><img src={Youtube} alt="youtube icon" /></a>
                    <a href='https://www.snapchat.com/sixyardjo' target='_blank' rel="noreferrer"><img src={SnapChat} alt="snapChat icon" /></a>
                    <a href='https://www.instagram.com/6yardjo/' target='_blank' rel="noreferrer"><img src={Instagram} alt="instagram icon" /></a>
                    <a href='https://x.com/6yardjo' target='_blank' rel="noreferrer"><img src={Twitter} alt="twitter icon" /></a>
                    <a href='https://www.tiktok.com/6yardjo' target='_blank' rel="noreferrer"><img src={Tiktok} alt="tiktok icon" /></a>
                </div>
            </div>
        </div>
    );
};

export default ContactDetails;
